<div class="box box-info">
  <div class="box-header with-border">
    <h3 class="box-title">Edit Beneficiary</h3>
  </div>
  <!-- /.box-header -->
  <!-- form start -->
  <form class="form-horizontal" role="form" [formGroup]="form" novalidate>
    <div class="box-body">
      <div class="form-group">
        <label class="col-sm-3 control-label">Choose beneficiary</label>

        <div class="col-sm-9">
          @if (beneficiaries) {
            <select
              class="form-control"
              (change)="onChange($event.target.value)"
              formControlName="id"
              >
              <option value="">select a Beneficiary</option>
              @for (item of beneficiaries; track item) {
                <option value="{{ item.id }}">{{
                  item.title
                }}</option>
              }
            </select>
          }
          @if (
            form.controls['id'].hasError('required') &&
            (form.controls['id'].touched || attemptedSubmit)
            ) {
            <control-message
              message="Beneficiary is required."
            ></control-message>
          }
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-3 control-label">New benficiary name</label>

        <div class="col-sm-9">
          <input type="text" class="form-control" formControlName="title" />
          @if (
            form.controls['title'].hasError('required') &&
            (form.controls['title'].touched || attemptedSubmit)
            ) {
            <control-message
              message="Name is required."
            ></control-message>
          }
        </div>
      </div>
    </div>
    <!-- /.box-body -->
    <div class="box-footer">
      <div class="box-footer">
        <button
          type="button"
          (click)="submitForm()"
          class="btn btn-info pull-right"
          >
          Edit Benficiary
        </button>
      </div>
    </div>
    <!-- /.box-footer -->
  </form>
</div>
